/*  MUI  */
import { Box, Grid, Typography } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';

/*  Images  */
import LoginPanelImage from 'images/login/ASM-home screen-image@2x.png';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

const RightHalf = () => {
    const { t } = useTranslation();
    return (
        <Box
            alignItems="center"
            backgroundColor="background.loginGraphic"
            data-testid="loginLayoutRightHalf"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            textAlign="center"
            width="100%"
        >
            <img
                style={{
                    maxHeight: '100%',
                    maxWidth: '100%',
                    padding: '32px'
                }}
                src={LoginPanelImage}
                alt={t('Common.slogan')}
            />
            <Box padding="32px">
                <Typography
                    sx={{
                        color: 'text.white',
                        fontSize: FontSizes[5],
                        fontWeight: 600,
                        mt: '32px'
                    }}
                    dangerouslySetInnerHTML={{
                        __html: t('Common.sloganSplit')
                    }}
                />
                <Typography
                    sx={{
                        color: 'text.white',
                        fontSize: FontSizes[4],
                        mt: '32px'
                    }}
                    dangerouslySetInnerHTML={{
                        __html: t('Common.sloganPart2')
                    }}
                />
            </Box>
        </Box>
    );
};

export const LoginLayout = ({ children }) => (
    <Grid
        container
        alignItems="stretch"
        data-testid="loginPageContainer"
        sx={{
            backgroundColor: 'background.primary',
            height: '100%',
            overflowX: 'hidden',
            overflowY: 'auto'
        }}
    >
        <Grid
            item
            xs={12}
            md={6}
            data-testid="loginPageContainerLeft"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ backgroundColor: 'background.login' }}
        >
            {children}
        </Grid>
        <Grid
            item
            xs={12}
            md={6}
            display={['none', 'none', 'flex']}
            data-testid="loginPageContainerRight"
        >
            <RightHalf />
        </Grid>
    </Grid>
);
